import type { FileResult } from "../types";
import type { SessionFileRow } from "../types/sessionFile";

import { isSessionFileTransferring } from "./reconcileInFlightUploads";

/** Overlays multipart progress from `sessionFiles` onto snapshot-derived results. */
export function mergeResultsWithSessionFiles(
  results: FileResult[],
  sessionFiles: SessionFileRow[],
): FileResult[] {
  const sessionByAttachmentId = new Map(
    sessionFiles
      .filter((row) => row.attachmentId !== null)
      .map((row) => [String(row.attachmentId), row] as const),
  );

  return results.map((result) => {
    const row = sessionByAttachmentId.get(result.id);

    if (!row) return result;

    const isTransferring = isSessionFileTransferring(row);

    return {
      ...result,
      displayName: row.displayName,
      file: row.file,
      isTransferring,
      status: isTransferring ? "loading" : result.status,
      uploadProgress: row.progress,
    };
  });
}
